import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../helper/BaseUrl";

const ProtectedRoute = ({ children }) => {
  const [isValid, setIsValid] = useState(null);
  const token = localStorage.getItem("accessTokenawl");

  useEffect(() => {
    let interval;
    let cancelled = false;

    const verifyUser = async () => {
      try {
        await axios.get(`${BaseUrl}api/rbac/my-permissions`, {
          headers: {
            "x-access-token": token,
          },
        });
        if (!cancelled) setIsValid(true);
      } catch (error) {
        const status = error.response?.status;
        if (status === 401 || status === 403) {
          localStorage.removeItem("accessTokenawl");
          localStorage.removeItem("username");
          localStorage.removeItem("email");
          if (!cancelled) setIsValid(false);
          return;
        }
        if (!cancelled) setIsValid(true);
      }
    };

    if (token) {
      verifyUser();
      interval = setInterval(verifyUser, 600000);
    } else {
      setIsValid(false);
    }

    return () => {
      cancelled = true;
      if (interval) clearInterval(interval);
    };
  }, [token]);

  if (isValid === null) {
    return <div>Loading...</div>;
  }

  return isValid ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;
